module.exports = __webpack_public_path__ + "static/EGO_Удобно и просто-7c6b4c2dcbed90bc24c446d8ef572c5a.png";